import { Outlet } from "react-router-dom";

const ProductCategories = () => <Outlet />;

export default ProductCategories;
